import fallbackPickerOptions from '../data/insurancePickerData';

const getInsuranceTypesService = async pageId => {
    // Force pageId to be a number
    pageId = parseInt(pageId);
    if (isNaN(pageId)) {
        pageId = 0; // Default Insurance Types use 0
    }

    return fetch(`/api/pageInsuranceTypes/${pageId}`)
        .then(async insuranceTypesRes => {
            let insuranceTypes = fallbackPickerOptions;
            if (insuranceTypesRes.ok) {
                insuranceTypes = await insuranceTypesRes.json();
            }
            if (insuranceTypes.length === 0) {
                insuranceTypes = fallbackPickerOptions;
            }
            return insuranceTypes;
        })
        .catch(e => {
            return fallbackPickerOptions;
        });
};

export default getInsuranceTypesService;
